





































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { TsRateeUser } from '@/interfaces'
import dayjs from 'dayjs'
import { Getter } from 'vuex-class'

@Component({
  name: 'ManagerRateeCard'
})
export default class ManagerRateeCard extends Vue {
  @Prop({ required: true })
  ratee!: TsRateeUser

  @Getter('ts/hasRoleRater')
  hasRoleRater!: boolean;

  @Getter('ts/hasRoleManager')
  hasRoleManager!: boolean;

  get formattedExpiryDate (): string {
    if (this.ratee !== null && this.ratee.isLive && this.ratee.expiryTime) {
      return dayjs(this.ratee.expiryTime.toString()).format('DD/MM/YYYY')
    }
    return ''
  }

  get formattedDate (): string {
    if (this.ratee !== null && this.ratee.expiryTime) {
      return dayjs(this.ratee.expiryTime.toString()).format('DD/MM/YYYY')
    }
    return dayjs(new Date().toString()).format('DD/MM/YYYY')
  }

  publish (): void {
    this.$modal.show('confirm-publish-modal')
  }
}
